module.exports = __webpack_public_path__ + "static/media/reparaciones.d44cc96b.png";